<template>
    <div :class="label ? 'd-flex align-center justify-space-between' : ''" class="mb-2">
        <div class="d-flex align-center flex-grow-1" v-if="label">
            <p class="text-grey-darken-2 text-meta">{{label}}:</p>
            <v-icon v-tooltip="tooltip" v-if="tooltip" class="cursor-help ms-2" color="secondary" size="18">info</v-icon>
        </div>
        <div class="d-flex align-center justify-center flex-grow-0">
            <p class="text-grey-darken-2 text-meta">{{falseLabel}}</p>
            <v-switch class="mt-0 mx-3" :color="color" v-model="localValue" :true-value="trueValue" :false-value="falseValue" hide-details></v-switch>
            <p class="text-grey-darken-2 text-meta">{{trueLabel}}</p>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        modelValue: {
            required: true,
            default: null
        },
        label: {
            type: String,
            default: null
        },
        trueValue: {
            default: true
        },
        falseValue: {
            default: false
        },
        trueLabel: {
            type: String,
            default: "فعال"
        },
        falseLabel: {
            type: String,
            default: "غیر فعال"
        },
        tooltip: {
            type: String,
            default: null
        },
        justify: {
            type: String,
            default: "start"
        },
        color: {
            type: String,
            default: 'secondary'
        }
    },
    computed: {
        localValue: {
            get: function () { return this.modelValue },
            set: function (value) { this.$emit('update:modelValue', value) }
        },
    },
}
</script>
